import { upperFirst } from 'es-toolkit';

import PropertyConstants from '../constants/PropertyConstants';

const DEFAULT_FILTER_VALUE = 'all';

const { PROPERTY_TYPES_BY_CODE } = PropertyConstants;

export function formatSearchString(
  beds: string | undefined,
  propertyType: number | string | undefined,
  searchArea: string,
  shouldCapitalize = false,
): string {
  // Convert undefined to 'all' for consistent handling
  const bedsValue = beds ?? DEFAULT_FILTER_VALUE;
  const propertyTypeValue = propertyType ?? DEFAULT_FILTER_VALUE;

  let searchString: string;

  const getPropertyTypeString = () => {
    const propertyTypeVal = PROPERTY_TYPES_BY_CODE[propertyTypeValue as keyof typeof PROPERTY_TYPES_BY_CODE];
    return propertyTypeVal ? propertyTypeVal.toLowerCase() : 'rental';
  };

  switch (true) {
    case bedsValue === DEFAULT_FILTER_VALUE && propertyTypeValue === DEFAULT_FILTER_VALUE:
      searchString = `all rentals in ${searchArea}`;
      break;
    case propertyTypeValue === DEFAULT_FILTER_VALUE:
      searchString = `${bedsValue} bedroom rentals in ${searchArea}`;
      break;
    case bedsValue === DEFAULT_FILTER_VALUE:
      searchString = `${getPropertyTypeString()}s in ${searchArea}`;
      break;
    default:
      searchString = `${bedsValue} bedroom ${getPropertyTypeString()}s in ${searchArea}`;
  }

  if (shouldCapitalize) {
    return upperFirst(searchString);
  }

  return searchString;
}
